export default __webpack_public_path__ + "static/media/app_match_summary-public-match.cbd180da.jpg";